import { VacationsRequest } from 'src/components/Timeoff/widgets/RequestsWidget/models/RequestWidget.interface';
import { VacationType } from 'src/tabs/hooks/useVacationTypes';
import { StatusEnum } from 'src/utils/mappers/checkStatusCode';
import { isMobile } from 'react-device-detect';

export const currentUserVacationRequestMapper = (
  requests: VacationsRequest[],
  vacationTypes: VacationType[]
) => {
  return requests
    .map((request) => {
      return {
        name: 'currentUser',
        status: request.statuscode_Formatted,
        startDate: !isMobile
          ? request.new_startdate.replace(/-/g, ',')
          : request.new_startdate,
        endDate: !isMobile
          ? request.new_enddate.replace(/-/g, ',')
          : request.new_enddate,
        vacation_type: vacationTypes.find(
          (vacation) =>
            vacation.new_axsvacationtypeid === request._new_vacationtype_value
        )?.new_name,
      };
    })
    .filter(
      (request) =>
        request.status !== StatusEnum.REJECTED &&
        request.status !== StatusEnum.CANCELLED
    );
};
